import { isBooleanControl, rankWith, and, optionIs } from '@jsonforms/core';
import controlRenderer from './BooleanControlRenderer.vue';

export const entry = {
  renderer: controlRenderer,
  tester: rankWith(10, and(isBooleanControl, optionIs('version', 'v2'))),
};
